module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-03-e5ebb6f2093634d22602ccea7ce9d506.jpg";